import { z } from 'zod';

export const legacyStatusSchema = z.object({
  id: z.number().int(),
  code: z.number().int(),
  name: z.string(),
  description: z.string(),
});

/**
 * php-api's per-response `meta` envelope, as it appears **on the wire**.
 *
 * Exactly four keys. `request_status` and `request_status_message` are absent on purpose: `render()`
 * prepends them to the data *after* `prerender()` has already serialised the body, and `_render()`
 * echoes that pre-built string — while its one re-encoding branch unsets both as `$debug_keys`
 * (`responder.class.php:72-73`). All three paths omit them.
 *
 * `meta.errors` is not modelled here: no endpoint using this helper today has an error branch that a
 * well-formed request can reach. Add it — from
 * `libs/business-configuration/partners/core/src/schemas/partners.schemas.ts` — when one does.
 */
export const legacyResponseMetaSchema = z.object({
  /** Per-request id (`error::get_series()`); mapped to hunkware-api's correlation id. */
  series: z.string(),
  /** `Environment::current() . '-' . $instanceId`; mapped to `<ENVIRONMENT>-<hostname>`. */
  instance: z.string(),
  /** Whole milliseconds spent in the request (`round(...)`). */
  run_time: z.number().int(),
  status: legacyStatusSchema,
});

export type LegacyResponseMeta = z.infer<typeof legacyResponseMetaSchema>;
